/* eslint-disable */
import { defineStore } from 'pinia';
import { useRegionsStore } from './regions';
import { useCompetitionsStore } from './competitions';
import { usePreSportsStore } from './pre_sports';
import { useCustomerStore } from '@/stores/customer';
import { useSocketStore } from '@/stores/socket';
import router from '@/router/router';
import { useDatesStore } from './dates';
import _ from 'lodash';
import { protonMassDependencies } from 'mathjs';
import { useFavouritesStore } from './favourites';
import { usePlatformConfigurationStore } from './platform_configuration';

export const useDateTimeSportFiltersStore = defineStore('date_time_sport_filters', {
	state: () => ({
		selected_option: usePlatformConfigurationStore().sortUpcomingDays ? 'today' : 'all',
		date_from: null,
		date_to: null,
		utc_offset: null,
		hours_list: [],
		days_list: [],
		selected_regions: [],
		visible_region: null,
		filtered_fixtures: [],
		quick_picks_counters: null,
		upcoming_days_info: {},
		upcoming_hours_info: {},
		socket_competition_ids: [],
		sort: 'default',
		expand_datetime: false,
		expand_competitions: false,
		expand_sort: false,
		selected_overview_market: null,
		time_fixtures: [],
		current_page: 1,
		last_page: 1,
		is_loading: false,
	}),
	getters: {
		getUpcomingDaysInfo(state) {
			const platformConfigurationStore = usePlatformConfigurationStore();

			if (!platformConfigurationStore.sortUpcomingDays) {
				return state.upcoming_days_info;
			}

			if (!state.upcoming_days_info) return [];

			const days_array = Object.values(state.upcoming_days_info);

			const all_day = days_array.find(day => day.slug === 'all');
			const other_days = days_array.filter(day => day.slug !== 'all');

			return all_day ? [...other_days, all_day] : other_days;
		},
		getQuickPicksTodayCounter: (state) => {
			if (!state.quick_picks_counters) return null;
			return state.quick_picks_counters.todays_count;
		},
		getQuickPicks48HoursCounter: (state) => {
			if (!state.quick_picks_counters) return null;
			return state.quick_picks_counters.next_48_hours;
		},
		getQuickPicks24HoursCounter: (state) => {
			if (!state.quick_picks_counters) return null;
			return state.quick_picks_counters.next_24_hours;
		},
		getUpcomingDaysData : (state) => (day_slug) => {
			if (!state.upcoming_days_info) return null;

			if (Object.prototype.hasOwnProperty.call(state.upcoming_days_info, day_slug)) {
				return state.upcoming_days_info[day_slug];
			}
			return null;
		},

		getUpcomingHoursData : (state) => (hour_slug) => {
			if (!state.upcoming_hours_info) return null;

			const prefixed_slug = `next_${hour_slug}`;
			if (Object.prototype.hasOwnProperty.call(state.upcoming_hours_info, prefixed_slug)) {
				return state.upcoming_hours_info[prefixed_slug];
			}
			return null;
		},
		getCompetitionsWithRegion() {
			const regionsStore = useRegionsStore();
			if (!regionsStore.regionsCompetitions)  return;

			let regions = regionsStore.regions_competitions;

			if (this.selected_option == 'all') {
				regions = regionsStore.regions_competitions_all;
			}

			if (router.currentRoute.value.params.competition_ids && this.selected_regions.length == 0) {
				return [];
			};

			const return_competitions = {};
			if (this.selected_regions.length > 0) {
				for (let index = 0; index < this.selected_regions.length; index++) {
					const region = this.selected_regions[index];

					const found_region = _.find(regions, {id: region.region_id});
					if (found_region) {
						if (found_region.hasOwnProperty('pre_fixtures_count') && found_region.pre_fixtures_count == 0) continue;
						for (let j = 0; j < region.competition_ids.length; j++) {
							if (found_region.competitions[region.competition_ids[j]]) {
								let mixani_competition = found_region.competitions[region.competition_ids[j]]
								return_competitions[mixani_competition.id] = { id: mixani_competition.id, name: mixani_competition.name, weight: mixani_competition.weight, icon_url: found_region.icon, region_name: found_region.name, fixtures_count: mixani_competition.fixtures_count };
							}

						}
					}
				}
				return _.orderBy(return_competitions, 'weight', 'desc');
			}


			for (const region_id in regions) {
				const region = regions[region_id];
				if (region.hasOwnProperty('pre_fixtures_count') && region.pre_fixtures_count == 0) continue;

				for (const competition_id in region.competitions) {
					const competition = region.competitions[competition_id];

					return_competitions[competition_id] = { id: competition.id, name: competition.name, weight: competition.weight, icon_url: region.icon, region_name: region.name, fixtures_count: competition.fixtures_count };
				}

			}

			return _.orderBy(return_competitions, 'weight', 'desc');
		},
		getTimeFixtures(state) {
			if (_.isEmpty(state.time_fixtures)) return {};

			return _.groupBy(state.time_fixtures, 'formatted_date');
		},
		showButtonCount(state) {
			if (state.selected_regions.length != 0) return _.sumBy(state.getCompetitionsWithRegion,'fixtures_count');

			if (!state.upcoming_days_info) return;
			if (!state.upcoming_hours_info) return;
			if (state.upcoming_days_info[state.selected_option]) return state.upcoming_days_info[state.selected_option]?.fixtures_count;
			if (state.upcoming_hours_info['next_' + state.selected_option]) return state.upcoming_hours_info['next_' + state.selected_option]?.fixtures_count;
			return
		},
		favouritesFixtureBySportCompetition(state) {
			let fixtures = useFavouritesStore().preFixtureOverviews;

			for (const fixture_id in fixtures) {
				if (Object.hasOwnProperty.call(fixtures, fixture_id)) {
					fixtures[fixture_id].favourite = true;
					fixtures[fixture_id]['competition_region_name'] = fixtures[fixture_id].region_name + ' - ' + fixtures[fixture_id].competition_name;
				}
			}

			let grouped_by_sport = _.chain(fixtures).groupBy('sport_id').value();

			for (const sport_id in grouped_by_sport) {
				if (Object.hasOwnProperty.call(grouped_by_sport, sport_id)) {
					const element = grouped_by_sport[sport_id];
					grouped_by_sport[sport_id] = _.groupBy(element, 'competition_region_name');
				}
			}

			return grouped_by_sport;

		},
	},
	actions: {
		fetchQuickPicksCounters(sport_id = null) {
			const preSportsStore = usePreSportsStore();
			const customerStore = useCustomerStore();

			if (sport_id == null) sport_id =  preSportsStore.selectedPreSportId;

			return global.axios.get(process.env.VUE_APP_SPORTSBOOK_API_URL + '/sport/' + sport_id + '/info', { params: { utc_offset: customerStore.getCustomersUtcOffset } }).then((response) => {
				this.quick_picks_counters = response.data;

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		fetchCompetitionsPerRegion() {
			const preSportsStore = usePreSportsStore();
			const customerStore = useCustomerStore();

			if (this.date_from == 'all') {
				const regionsStore = useRegionsStore();
				regionsStore.fetchRegions(preSportsStore.selectedPreSportId)
				return;
			}

			if (this.selected_option != this.date_from) {
				this.date_from = this.selected_option;
			}

			let payload = {
				from: this.date_from,
				utc_offset: customerStore.getCustomersUtcOffset
			}

			return global.axios.get(process.env.VUE_APP_SPORTSBOOK_API_URL + '/sport/' + preSportsStore.selectedPreSportId + '/competitions-per-region', { params: payload }).then((response) => {
				const regionsStore = useRegionsStore();
				regionsStore.regions_competitions = response.data.regions;

				const competitionsStore = useCompetitionsStore();
				competitionsStore.top_competitions = response.data.top_competitions;

				this.syncSelectedWithAvailable(response.data.regions);
				// this.fetchUpcomingDaysInfo();

				return Promise.resolve(response.data);
			}).catch((error) => {
				console.log(error)
				return Promise.resolve(error);
			})
		},
		updateSelectedRegion(region_id, competition_id, is_selected) {
			let region_index = this.selected_regions.findIndex(r => r.region_id === region_id);

			if (is_selected) {
				if (region_index === -1) {
					// Add new region entry if it doesn't exist
					this.selected_regions.push({
						region_id: region_id,
						competition_ids: [competition_id]
					});
				} else {
					// Add competition to existing region if not already there
					if (!this.selected_regions[region_index].competition_ids.includes(competition_id)) {
						this.selected_regions[region_index].competition_ids.push(competition_id);
					}
				}
			} else {
				// Deselecting: Remove competition from region
				if (region_index !== -1) {
					this.selected_regions[region_index].competition_ids = this.selected_regions[region_index].competition_ids.filter(
						id => id !== competition_id
					);

					// Optional: Remove the region object entirely if no competitions are left
					if (this.selected_regions[region_index].competition_ids.length === 0) {
						this.selected_regions.splice(region_index, 1);
					}
				}
			}
		},
		bulkUpdateRegion(region_id, competitions, is_fully_selected) {
			let region_index = this.selected_regions.findIndex(r => r.region_id === region_id);

			if (is_fully_selected) {
				const ids = competitions.map(c => c.id);
				if (region_index === -1) {
					this.selected_regions.push({ region_id: region_id, competition_ids: ids });

				} else {
					this.selected_regions[region_index].competition_ids = ids;
				}
			} else {
				// If deselecting the whole region, remove it from the array
				if (region_index !== -1) {
					this.selected_regions.splice(region_index, 1);
				}
			}
		},
		syncSelectedWithAvailable(new_regions_obj) {
			// Iterate backwards through selected_regions to allow safe removal (splice)
			for (let i = this.selected_regions.length - 1; i >= 0; i--) {
				const selected = this.selected_regions[i];

				// 1. Direct lookup by key instead of .find()
				const available_region = new_regions_obj[selected.region_id];

				if (!available_region) {
					// Region ID not found in the new object keys
					this.selected_regions.splice(i, 1);
					continue;
				}

				// 2. Filter competitions
				// Since competitions is also an object: { "9311": {...}, "9313": {...} }
				const available_competitions = available_region.competitions || {};

				selected.competition_ids = selected.competition_ids.filter(id => {
					// Check if the competition ID exists as a key in the competitions object
					return Object.prototype.hasOwnProperty.call(available_competitions, id);
				});

				// 3. Cleanup: If no competitions are left for this region, remove the region
				if (selected.competition_ids.length === 0) {
					this.selected_regions.splice(i, 1);
				}
			}
		},
		resetStore() {
			// this.selected_option = 'all';
			this.date_from = null;
			this.date_to = null;
			this.hours_list = [];
			this.days_list = [];
			// this.selected_regions = [];
			this.visible_region = null;
			// this.sort = 'default';
			this.expand_datetime = false;
			this.expand_competitions = false;
			this.expand_sort = false;
			// this.selected_overview_market = null;
		},
		fullyResetStore() {
			this.selected_option = 'all';
			this.date_from = null;
			this.date_to = null;
			this.hours_list = [];
			this.days_list = [];
			this.selected_regions = [];
			this.visible_region = null;
			this.sort = 'default';
			this.expand_datetime = false;
			this.expand_competitions = false;
			this.expand_sort = false;
			// this.selected_overview_market = null;
		},
		fetchSingleCompetitionFixtures(competition_id) {
			const preSportsStore = usePreSportsStore();
			const customerStore = useCustomerStore();
			// const socketStore = useSocketStore();

			let payload = {
				competition_ids: competition_id,
				utc_offset: customerStore.getCustomersUtcOffset
			};

			if (this.date_from != 'all') {
				payload.from = this.date_from;
			}

			// if (!this.date_from && !this.date_to) {
			// 	let competition_ids = final_ids_string.split(',');
			// 	competition_ids.forEach(competition_id => {
			// 		socketStore.join('competitionFixtures', competition_id)
			// 	});

			// 	this.socket_competition_ids = competion_ids ? competion_ids : this.selected_regions.flatMap(region => region.competition_ids).filter(id => id);

			// 	return Promise.resolve();
			// } else if (this.date_from && this.date_to && this.socket_competition_ids.length > 0) {
			// 	this.socket_competition_ids.forEach(competition_id => {
			// 		socketStore.leave('competitionFixtures', competition_id);
			// 	});

			// 	this.socket_competition_ids = [];
			// }

			return global.axios.get(process.env.VUE_APP_SPORTSBOOK_API_URL + '/sport/' + preSportsStore.selectedPreSportId + '/upcoming-events', { params: payload }).then((response) => {
				const competitonsStore = useCompetitionsStore();

				// competitonsStore.emptyCompetitions();

				response.data.forEach(fixture_data => {
					competitonsStore.setCompetitionFixtures(fixture_data);
				});

				return Promise.resolve(response.data);
			}).catch((error) => {
				console.log(error)
				return Promise.reject(error);
			})

		},
		async fetchTimeFixtures(params, is_next_page = false) {
			if (this.is_loading) return;

			if (!is_next_page) this.current_page = 1;

			this.is_loading = true;
			const preSportsStore = usePreSportsStore();
			const customerStore = useCustomerStore();

			let payload = {
				utc_offset: customerStore.getCustomersUtcOffset,
				page: this.current_page,
			}

			if (this.date_from != 'all') {
				payload.from = this.selected_option;
			}

			if (params.competition_ids) {
				payload.competition_ids = params.competition_ids;
			}

			return global.axios.get(process.env.VUE_APP_SPORTSBOOK_API_URL + '/sport/' + preSportsStore.selectedPreSportId + '/upcoming-paginated', { params: payload }).then((response) => {
				const dates_store = useDatesStore();

				const processed_fixtures = response.data.data.map(fixture => ({
					...fixture,
					formatted_date: dates_store.competitionFixtureDate(fixture.start_datetime)
				}));

				if (is_next_page) this.time_fixtures = [...this.time_fixtures, ...processed_fixtures];
				else this.time_fixtures = processed_fixtures;

				this.current_page = response.data.meta.current_page ?? response.data.meta.page ?? 1;
				this.last_page = response.data.meta.last_page ?? response.data.meta.total_pages ?? 1;

				return Promise.resolve(response.data);
			}).catch((error) => {
				console.log(error)
				return Promise.reject(error);
			}).finally(() => {
				this.is_loading = false;
			})

		},
		loadMoreFixtures(params = {}) {
			if (this.current_page < this.last_page && !this.is_loading) {
				this.current_page++;
				return this.fetchTimeFixtures(params, true);
			}
		},
		fetchUpcomingDaysInfo(competion_ids = null) {
			const preSportsStore = usePreSportsStore();
			const customerStore = useCustomerStore();


			console.log('aaaa', preSportsStore.selectedPreSportId);
			if (preSportsStore.selectedPreSportId == -1) return Promise.reject();
			let final_ids_string;

			if (!competion_ids && this.selected_regions.length == 0) {
				final_ids_string = null;
			} else {
				let ids_source = competion_ids ? competion_ids : this.selected_regions.flatMap(region => region.competition_ids).filter(id => id);
				final_ids_string = Array.isArray(ids_source) ? ids_source.join(',') : ids_source;
			}

			let payload = {
				utc_offset: customerStore.getCustomersUtcOffset,
				competition_ids: final_ids_string
			};

			return global.axios.get(process.env.VUE_APP_SPORTSBOOK_API_URL + '/sport/' + preSportsStore.selectedPreSportId + '/upcoming-days/info', { params: payload }).then((response) => {
				this.upcoming_days_info = response.data.days;
				this.upcoming_hours_info = response.data.next_hours;

				return Promise.resolve(response.data);
			}).catch((error) => {
				console.log(error)
				return Promise.reject(error);
			})
		},
		setSelectedRegionsFromIds(ids_array) {
			const regionsStore = useRegionsStore();
			const grouped = {};

			let regions = regionsStore.regions_competitions;

			if (this.selected_option == 'all') {
				regions = regionsStore.regions_competitions_all;
			}

			if (!regions) return;

			// 1. Iterate through all available regions to find where these competitions belong
			// We assume regions is already loaded
			Object.values(regions).forEach(region => {
				const match_ids = Object.keys(region.competitions).filter(id =>
					ids_array.includes(id.toString())
				);

				if (match_ids.length > 0) grouped[region.id] = match_ids;
			});

			// 2. Format for selected_regions state
			this.selected_regions = Object.entries(grouped).map(([region_id, comp_ids]) => ({
				region_id: region_id,
				competition_ids: comp_ids
			}));
		},
		async setSelectedOptionByDates(date_from) {
			const days_array = Object.values(this.upcoming_days_info);
			const hours_array = Object.values(this.upcoming_hours_info);

			const all_options = [...days_array, ...hours_array];

			const matched_option = all_options.find(item => {
				return item.slug === date_from;
			});

			if (matched_option) this.selected_option = matched_option.slug;
			else this.selected_option = 'all';
		},
		clearTimeFixtures() {
			this.time_fixtures = [];
			this.current_page = 1;
			this.last_page = 1;
			this.is_loading = false;
		},
	},
	persist: {
		storage: localStorage,
		paths: ['sort'],
	},
})